import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { contractDataSaga } from './saga';
import { amendment, biData, biDetailState, ContractErrorType } from './types';

export let initialState: biDetailState = {
  contractNumber: '',
  biDetail: null,
  contractInfoView: null,
  recurringView: null,
  oneOffView: null,
  depositView: null,
  previewMode: true,
  displayData: null,
  previousRecurring: [],
  error: null,
};

const slice = createSlice({
  name: 'biDetailState',
  initialState,
  reducers: {
    setContractNumber(state, action: PayloadAction<string>) {
      state.contractNumber = action.payload;
    },
    reposLoaded(state, action: PayloadAction<biDetailState>) {
      state.biDetail = action.payload.biDetail;
      state.contractInfoView = action.payload.contractInfoView;
      state.recurringView = action.payload.recurringView;
      state.oneOffView = action.payload.oneOffView;
      state.depositView = action.payload.depositView;
      state.previousRecurring = action.payload.previousRecurring ?? [];
      state.error = null;
    },
    updatePreviewModes(state, action: PayloadAction<boolean>) {
      state.previewMode = action.payload;
    },
    updateOriginalView(state, action: PayloadAction<biData>) {
      if (state.biDetail) {
        state.biDetail.view = action.payload;
      }
    },
    setDisplayData(state, action: PayloadAction<biData>) {
      state.displayData = action.payload;
    },
    updateAmendments(state, action: PayloadAction<amendment[]>) {
      if (state.biDetail) {
        state.biDetail.amendment = action.payload;
      }
    },
    setContractError(state, action: PayloadAction<ContractErrorType>) {
      state.error = action.payload;
    },
  },
});

export const { actions: contractDataActions, reducer } = slice;

export const useContractDataSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: contractDataSaga });
  return { actions: slice.actions };
};